import React from 'react';
import { useHistory } from 'react-router-dom';
import { colorSet } from '@components/Provider';
import NotificationContainer from '@components/Notification';
import GnbCheckerBoardMenu from '../GnbCheckerBoardMenu';
import GnbPopupMenu from '../GnbPopupMenu';
import { useMediaQuery, useTheme, makeStyles } from '@material-ui/core';
import { CustomizedButton } from '@components/Customized';
import useClient from '@hooks/useClient';
import useUserActionLog, {
  Enum_Action_Button_Enum,
  CapaActivityType
} from '@hooks/useUserActionLog';
import useIframe from '@hooks/useIframe';

export const useStyleExtraBtn = makeStyles(() => ({
  extraBtn: (props: { isBlog: boolean }) => ({
    display: 'flex',
    alignItems: 'center',
    color: colorSet.gray900,
    '& .gnb-checkerboard-menu': {
      marginLeft: 8
    },
    '& .gnb-popup-menu': {
      marginLeft: 8
    },
    '& .gnb-blog': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
      cursor: 'pointer',

      '& .gnb-blog-btn': {
        color: props.isBlog ? colorSet.primary500 : colorSet.gray600,
        marign: '0 auto'
      }
    },
    '& .gnb-rfq': {
      marginLeft: 8
    },
    '& .gnb-login': {
      marginLeft: 16,
      color: colorSet.gray900
    }
  }),
  notification: {
    marginLeft: 16
  }
}));

const GnbExtraBtnPresenter: React.FC = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));
  const location = window.location.href.includes('/blog');
  const classes = useStyleExtraBtn({ isBlog: location });
  const history = useHistory();
  const { clientState } = useClient();
  const isAuth = Boolean(clientState?.accessToken);
  const { onInsertUserActionLogOne } = useUserActionLog();

  const { postMessage } = useIframe();

  const postMessageToIframe = () => {
    postMessage({
      iframeId: 'blog-iframe',
      message: {
        key: 'go-index'
      },
      origin: '*'
    });
  };

  return (
    <div className={classes.extraBtn}>
      <div
        className="gnb-blog"
        onClick={() => {
          postMessageToIframe();
          history.push('/blog');
        }}
      >
        <CustomizedButton className="gnb-blog-btn" variant="text">
          블로그
        </CustomizedButton>
      </div>

      {isAuth && (
        <div className={classes.notification}>
          <NotificationContainer />
        </div>
      )}
      <GnbCheckerBoardMenu />
      {!matches && isAuth && <GnbPopupMenu />}
      {!isAuth && (
        <CustomizedButton
          className="gnb-login"
          color="secondary"
          variant="contained"
          onClick={() => history.push('/login')}
        >
          로그인/회원가입
        </CustomizedButton>
      )}
      <CustomizedButton
        className="gnb-rfq "
        variant="contained"
        color="primary"
        size="medium"
        onClick={() => {
          onInsertUserActionLogOne(
            Enum_Action_Button_Enum.Button_Gnb_CreateRfq,
            CapaActivityType.ButtonClick
          );
          history.push('/request');
        }}
      >
        <i className="request-gtm-startMakeRFQ-btn">견적 요청하기</i>
      </CustomizedButton>
    </div>
  );
};

export default GnbExtraBtnPresenter;
